import './css/main.css';
import './../css/checkbox.css'
import $ from 'jquery';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import edit_button from './img/edit_black_24dp.svg';
import '../common/css/errors.css';
import { useForm} from "react-hook-form";
import { Auth } from 'aws-amplify';
//import moment from 'moment'
const { FinnishBusinessIds } = require('finnish-business-ids')



const countries  = require('country-data').countries;
const initialPageInfo = {
  page: 'userProfile',
}
const initialUserInfo = {
  firstName: '',
  lastName: '',
  country: '',
  city: '',
  email: '',
  phoneNumber:'',
  postalCode: '',
  streetAddress: '',
  targetedMarketing:'',
  newsLetterSubscription:'',
  companyName: '',
  companyID: ''
}





const UserProfile = props => {
  const { reset, register: registerEditProfile, handleSubmit: handleEditProfile, formState: { errors: errorsEditProfile } } = useForm();
  const { register: registerEditUser, handleSubmit: handleEditUser, getValues: getValuesEditUser, formState: { errors: errorsEditUser } } = useForm();
  const { register: registerDeleteUser, handleSubmit: handleDeleteUser, formState: { errors: errorsDeleteUser } } = useForm();



  const [userProfile, updateUserProfile] = useState(initialUserInfo)
  const [userProfile2, updateUserProfile2] = useState(initialUserInfo)
  const callCustomerBackend = "https://" +  window.location.hostname + "/php/controllers/Customer.php";
  //console.log(callCustomerBackend)


  $('.userProfile_save').click( async function(){
    if (!$(this).hasClass('disabled')){
      $(this).addClass('disabled')
      let data_status = await saveUserProfile;
      if (data_status === 'success'){
        $(this).removeClass('disabled')
      }
    }
  } )
  async function saveUserProfile(data, formName) {
    //console.log(data)
    //console.log(formName)

    var firstName = userProfile.firstName;
    var lastName = userProfile.lastName;
    var streetAddress = userProfile.streetAddress;
    var postalCode = userProfile.postalCode;
    var city = userProfile.city;
    var country = userProfile.country;
    var phoneNumber = userProfile.phoneNumber;
    var targetedMarketing = userProfile.targetedMarketing;
    var newsLetterSubscription = userProfile.newsLetterSubscription;

    var companyName = userProfile.companyName;
    var companyID = userProfile.companyID;

    if(formName === "editProfile"){
      firstName = data.firstName;
      lastName = data.lastName;
      streetAddress = data.streetAddress;
      postalCode = data.postalCode;
      city = data.city;
      country = data.country;
      phoneNumber = data.phoneNumber;
      companyName = data.companyName;
      companyID = data.companyID;

    }else if(formName === "editUser"){
      changepassword(data)
      return
    }else if(formName === "editSubscriptions"){
      targetedMarketing = data.targetedMarketing;
      newsLetterSubscription = data.newsLetterSubscription;
    }else{
      console.log("Not a valid form")
    }
    const save_user_data = {
      'function': 'updateUser',
      "authToken" : props.user.signInUserSession.accessToken.jwtToken,
      'firstName' : firstName,
      'lastName' : lastName,
      'streetAddress' : streetAddress,
      'postCode' : postalCode,
      'city' : city,
      'country' : country,
      'phoneNumber' : phoneNumber,
      'targetedMarketing' : targetedMarketing,
      'newsLetterSubscription' : newsLetterSubscription,
      'companyName' : companyName,
      'companyID' : companyID,
    }
    saveUserDataToCognito(firstName,lastName)
    //console.log(save_user_data)

    axios.post(callCustomerBackend, save_user_data)
    .then(result => {
      if (result.data.status === "200"){
        //console.log(result.data)

        if(formName === "editSubscriptions"){
          $('.general_success_informer').html('Muutokset on tallennettu.').show();
          setTimeout(() => {
            $('.general_success_informer').html('');
          }, 3000);
        }
        return('success');
        updateUserProfile( () => userProfile );
        if (pageInfo.page =! 'userprofile'){
          changeTo('userProfile')
        }
      }
      else {
        return('error201');
      }
    })
    .catch(error => function(){
      console.log('error:' + error)
    })

  }

  async function saveUserDataToCognito(firstName,lastName){
    /*
    let result = await Auth.updateUserAttributes(props.user, {
        'name': firstName + " "+ lastName,
        'given_name': firstName,
        'family_name': lastName
    });
    */
    //update current user to parent
    props.user.attributes.name = firstName + " "+ lastName;
    props.user.attributes.given_name = firstName;
    props.user.attributes.family_name = lastName;
  }


  async function changepassword(data){
    //console.log(data)

    var oldPassword = data.oldpw
    var newPassword = data.newpw

    Auth.currentAuthenticatedUser()
    .then(user => {
        return Auth.changePassword(user, oldPassword, newPassword);
    })
    .then(data => {
      //console.log(data)

      if(data === "SUCCESS"){
       $('.general_success_informer').html('Salasanasi on vaihdettu onnistuneesti').show();
        setTimeout(() => {
            changeTo('userProfile')
            window.location.reload();
        }, 3000);
      }

    })
    .catch ((e) => {
      switch (e.message) {
        case 'Incorrect username or password.':
          $('.general_error_informer').html('Käyttäjätunnus tai salasana on väärin.').show();
          break;
        case 'Attempt limit exceeded, please try after some time.':
          $('.general_error_informer').html('Yritysraja ylitetty, yritä jonkin ajan kuluttua.').show();
          break;
        default:
      }
    })

  }


  useEffect(() => {
    const post_data = {
      'function' : 'user',
      "authToken" : props.user.signInUserSession.accessToken.jwtToken
    }

    axios.post(callCustomerBackend, post_data)
    .then(result => {
        console.log(result.data)
        if (result.data.status === "200"){
          updateUserProfile(() => ({
            firstName: result.data.content[0].firstName,
            lastName: result.data.content[0].lastName,
            city: result.data.content[0].city,
            email: result.data.content[0].email,
            country: result.data.content[0].Country,
            phoneNumber:result.data.content[0].phoneNumber,
            postalCode: result.data.content[0].postalCode,
            streetAddress: result.data.content[0].streetAddress,
            targetedMarketing: result.data.content[0].targetedMarketing,
            newsLetterSubscription : result.data.content[0].newsLetterSubscription,
            companyName: result.data.content[0].companyName,
            companyID: result.data.content[0].companyID,
            superUser: result.data.content[0].superUser,

          }))
        }
        else{
          $('.content').html('Virhe profillia ladattaessa')
        }
    })
    .catch(error => function(){
      console.log('error:' + error)
      $('.content').html('Virhe profillia ladattaessa')
    })
  }, []);

  function checkbox_change(target){
    if ($(target).hasClass('checker')){
      target = $(target).parent()
    }
    if ($(target).hasClass('checked')){
      $(target).removeClass('checked')
      $(target).children('.checker').css({'display':'none'})
    }
    else{
      $(target).addClass('checked')
      $(target).children('.checker').css({'display':'block'})
    }
  }
  const [pageInfo, updatePageInfo] = useState(initialPageInfo)
  const changeTo = (pageToGo) =>{
    updatePageInfo(() => ({ ...pageInfo, page: pageToGo }))
    document.location.hash = pageToGo;
  }
  function goBackWithoutChanges(){
    changeTo('userProfile')
    updateUserProfile2(() => userProfile)
  }


  async function copyUserDataForSaving(data){
    await updateUserProfile(() => ({ ...userProfile,
      firstName: data.firstName,
      lastName: data.lastName,
      streetAddress: data.streetAddress,
      postalCode: data.postalCode,
      city: data.city,
      country: data.country,
      phoneNumber: data.phoneNumber,
      companyName: data.companyName,
      companyID: data.companyID,
    }))
  }

  async function saveUserInfo(data, formName){
    await copyUserDataForSaving(data);
    saveUserProfile(data, formName);
  }

  function dublicateUserProfile(){
    updateUserProfile2(() => userProfile)
  }


  const checkCompanyIDvalidation = (e) => {
    const validCompanyId = FinnishBusinessIds.isValidBusinessId(e.target.value)
    const validVatNumber = FinnishBusinessIds.isValidVatNumber(e.target.value)

    if(validCompanyId  === true || validVatNumber  === true){
      $('#companyID').removeClass("invalid");
      $('#editProfile_companyID').html('');
    }else if(e.target.value.length === 0){
      $('#companyID').removeClass("invalid");
      $('#editProfile_companyID').html('');
    }else{
      $('#editProfile_companyID').html('Tunnuksen on oltava muotoa 1234567-1 <br> tai FI12345671');
      $('#companyID').addClass("invalid");
      return
    }
  }

  const handle_EditProfile_submit = (data) => {
    const validCompanyId = FinnishBusinessIds.isValidBusinessId(data.companyID)
    const validVatNumber = FinnishBusinessIds.isValidVatNumber(data.companyID)
    if(data.companyID){
      if(validCompanyId  === true || validVatNumber  === true){
        $('#companyID').removeClass("invalid");
        $('#editProfile_companyID').html('');
      }else if(data.companyID === 0){
        $('#companyID').removeClass("invalid");
        $('#editProfile_companyID').html('');
      }else{
        $('#editProfile_companyID').html('Tunnuksen on oltava muotoa 1234567-1 <br> tai FI12345671');
        $('#companyID').addClass("invalid");
        return
      }
    }
    saveUserInfo(data, "editProfile")
    changeTo('userProfile')
  }

  const handle_EditUser_submit = (data) => {
    //console.log(data)
    saveUserInfo(data, "editUser")
    //changeTo('userProfile')
  }
  const handle_DeleteUser_submit = (data) => {

    if (!$("#delete_checkbox").hasClass('checked')) {
      $('.general_error_informer').html('Hyväksy jäsenyyden lopetus').show();
      $('.accept_terms span').flashText()
      return;
    }
    if(data.email === userProfile.email){
      deleteUser()
    }else{
      $('.general_error_informer').html('Käyttäjätunnus on väärin').show();
    }
  }

  async function deleteUser() {
    try {
      // delete from DB
      const post_data = {
        'function' : 'deleteUser',
        "authToken" : props.user.signInUserSession.accessToken.jwtToken
      }
      axios.post(callCustomerBackend, post_data)
      .then(result => {
        console.log(result.data)
      })
      .catch(error => console.log('error:' + error));


      // delete user from cognito
      Auth.currentAuthenticatedUser()
      .then((user: CognitoUser) => new Promise((resolve, reject) => {
        user.deleteUser(error => {
          if (error) {
              return reject(error);
          }

          // Redirect user to login page
          document.location.href = "/signIn";
          $('.thx').text("Kiitos jäsenyydestäsi").show()
          resolve();
        });
      }))
    }catch (error) {
      console.log('Error deleting user', error);
    }
  }



  const handle_EditUserSubscriptions_submit = () => {
    var marketing = document.getElementById('marketketing_checkbox');
    var newsletter = document.getElementById('newsletter_checkbox');
    var targetedMarketing_value = 0;
    var newsletter_value = 0;
    if(marketing.classList.contains('checked')){
      var targetedMarketing_value = 1;
    }
    if(newsletter.classList.contains('checked')){
      var newsletter_value = 1;
    }
    const data = {
      "targetedMarketing" : targetedMarketing_value,
      "newsLetterSubscription": newsletter_value
    }
    saveUserSubscriptions(data, "editSubscriptions")
  }
  async function saveUserSubscriptions(data, formName){
    await copyUserDataForSavingSubscriptions(data);
    saveUserProfile(data, formName);
  }
  async function copyUserDataForSavingSubscriptions(data){
    await updateUserProfile(() => ({ ...userProfile,
      targetMarketing: data.targetedMarketing,
      newsLetterSubscription: data.newsLetterSubscription
    }))
  }

  /* test console */
  console.log("userProfile")
  console.log(userProfile);
  console.log("userProfile2")
  console.log(userProfile2);
  console.log("errors")
  console.log(errorsEditProfile, errorsEditUser, errorsDeleteUser);
  


  useEffect(() => {
    let defaultValues = {};
    defaultValues.firstName = userProfile2.firstName;
    defaultValues.lastName = userProfile2.lastName;
    defaultValues.streetAddress = userProfile2.streetAddress;
    defaultValues.postalCode = userProfile2.postalCode;
    defaultValues.city = userProfile2.city;

    // if country exist show it, otherwise set FI as default value
    if(userProfile2.country){
      defaultValues.country = userProfile2.country;
    }else{
      defaultValues.country = "FI";
    }

    defaultValues.phoneNumber = userProfile2.phoneNumber;
    defaultValues.companyName = userProfile2.companyName;
    defaultValues.companyID = userProfile2.companyID;
    reset({ ...defaultValues });
  }, [userProfile2]);



  const ScrollToTheTop = () => {
     window.scrollTo(0, 0)
  }

  /*
  const capitalizeFirst = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  */

  console.log(userProfile)
  
  return(
    <div className="inline">
    {
      pageInfo.page === 'loading' && (
        <div className="content">
        <div className="breadcrumb"><div onClick={event => props.onChange('landing')}>Oma eKukka</div> &gt; </div>
        <div className="h1">Omat tiedot</div>
          <div>Ladataan profiilia...</div>
        </div>
      )
    }
    {
      pageInfo.page === 'userProfile' && (
      <div className="content width100">
        {ScrollToTheTop()}
        <div className="breadcrumb"><div onClick={event => props.onChange('landing')}>Oma eKukka</div> &gt; Omat tiedot </div>
        <div className="h1">Omat tiedot</div>
        <div className="user_profile">
          <div className="h2">Yhteystiedot <img alt="editButton" className="edit_button" src={edit_button} onClick={() => {changeTo('editProfile'); dublicateUserProfile()}}/></div>
          <table><tbody>
          <tr className="first_name font_16"><td className="info">Etunimi</td><td className="answer">{userProfile.firstName}</td></tr>
          <tr className="last_name font_16"><td className="info">Sukunimi</td><td className="answer">{userProfile.lastName}</td></tr>
          <tr className="address font_16"><td className="info">Osoite</td><td className="answer">{userProfile.streetAddress} <br/>{userProfile.postalCode} {userProfile.city}</td></tr>
          <tr className="address font_16"><td className="info">Maa</td><td className="answer">{userProfile.country && countries[userProfile.country]?.name}</td></tr>
          <tr className="phone font_16"><td className="info">Puhelinnumero</td><td className="answer">{ userProfile.phoneNumber }</td></tr>
          <tr className="phone font_16"><td className="info">Yrityksen nimi</td><td className="answer">{userProfile.companyName && userProfile.companyName}</td></tr>
          <tr className="phone font_16"><td className="info">Yrityksen Y-tunnus</td><td className="answer">{userProfile.companyID && userProfile.companyID}</td></tr>
          </tbody></table>
        </div>
        <div className="user_settings">
          <div className="h2">Oma eKukka -jäsenyys <img  alt="editButton" className="edit_button" src={edit_button}  onClick={() => changeTo('editUser')}/></div>
          <table><tbody>
          <tr className="username font_16"><td className="info">Tunnus</td><td className="answer">{ userProfile.email }</td></tr>
          <tr className="Password font_16"><td className="info">Salasana</td><td className="answer">***********</td></tr>
          </tbody></table>
        </div>


        <div className="settings">
          <div className="h2">Asetukset</div>

            <div className="marketketing font_16">
              <div id="marketketing_checkbox" className={userProfile.targetedMarketing ? 'checkbox checked' : 'checkbox'} onClick={event => checkbox_change(event.target)}>
              <div className="checker" style={{ display: userProfile.targetedMarketing ? 'block' : 'none' }}/></div><span>Annan suostumuksen kohdennetulle markkinoinnille ja asiakasviestinnälle.</span>
            </div>

            <div className="kukkaystava font_16" style={{display: 'none'}}>
              <div id="newsletter_checkbox" className={userProfile.newsLetterSubscription ? 'checkbox checked' : 'checkbox'} onClick={event => checkbox_change(event.target)}>
              <div className="checker" style={{ display: userProfile.newsLetterSubscription ? 'block' : 'none' }}/></div><span>Kyllä, haluan Kukkaystävät-uutiskirjeen sähköpostiini.</span>
            </div>

            <div className='general_success_informer'></div>

            <div className="save_button mt10" onClick={handle_EditUserSubscriptions_submit}>Tallenna</div>
        </div>


        <div className="delete_account">
          <div className="remove_account">Jäsenyyden lopetus</div>
          <div className="font_16">Haluan <span className="delete_user_link" onClick={() => changeTo('deleteUser')}>lopettaa jäsenyyteni</span> Oma eKukassa.</div>
        </div>
      </div>
      )
    }
    {
      pageInfo.page === 'editProfile' && (
        <div className="content p0">
        <div className="user_account_edit">
            <div className="user_profile_edit">
              <div className="breadcrumb"><div onClick={event => props.onChange('landing')}>Oma eKukka</div> &gt; <div onClick={() => changeTo('userProfile')}>Omat tiedot</div> &gt; <div className="noPointer">Yhteystiedot</div> </div>
              <div className="h1">Yhteystiedot</div>

              <form onSubmit={handleEditProfile(handle_EditProfile_submit)}>
                <div className="input_container">
                  <span>Etunimi *</span>
                  <input type="text" className={errorsEditProfile.firstName ? 'invalid' : ''} id="firstName" onChange={e => updateUserProfile2(() => ({ ...userProfile2, firstName: e.target.value }))} {...registerEditProfile("firstName",{ required: true })} />
                  <div id="editProfile_firstname" className='form_error'>
                    {errorsEditProfile.firstName && errorsEditProfile.firstName?.type === "required" && (
                      "Etunimi on pakollinen kenttä"
                    )}
                  </div>
                </div>

                <div className="input_container">
                  <span>Sukunimi *</span>
                  <input type="text" className={errorsEditProfile.lastName ? 'invalid' : ''} id="lastName" onChange={e => updateUserProfile2(() => ({ ...userProfile2, lastName: e.target.value }))} {...registerEditProfile("lastName",{ required: true })}/>
                   <div id="editProfile_lastName" className='form_error'>
                    {errorsEditProfile.lastName && errorsEditProfile.lastName?.type === "required" && (
                      "Sukunimi on pakollinen kenttä"
                    )}
                  </div>
                </div>

                <div className="input_container">
                  <span>Katuosoite</span>
                  <input type="text" className={errorsEditProfile.streetAddress ? 'invalid' : ''} id="streetAddress" onChange={e => updateUserProfile2(() => ({ ...userProfile2, streetAddress: e.target.value }))} {...registerEditProfile("streetAddress",{ required: false })}/>
                   <div id="editProfile_streetAddress" className='form_error'>
                    {errorsEditProfile.streetAddress && errorsEditProfile.streetAddress?.type === "required" && (
                      "Katuosoite on pakollinen kenttä"
                    )}
                  </div>
                </div>

                <div className="input_container">
                  <span>Postinumero</span>
                  <input type="text" className={errorsEditProfile.postalCode ? 'invalid' : ''} id="postalCode" onChange={e => updateUserProfile2(() => ({ ...userProfile2, postalCode: e.target.value }))} {...registerEditProfile("postalCode",{ required: false })}/>
                   <div id="editProfile_postalCode" className='form_error'>
                    {errorsEditProfile.postalCode && errorsEditProfile.postalCode?.type === "required" && (
                      "Postinumero on pakollinen kenttä"
                    )}
                  </div>
                </div>

                <div className="input_container">
                  <span>Paikkakunta</span>
                  <input type="text"  className={errorsEditProfile.city ? 'invalid' : ''} id="city"  onChange={e => updateUserProfile2(() => ({ ...userProfile2, city: e.target.value }))} {...registerEditProfile("city",{ required: false })}/>
                  <div id="editProfile_city" className='form_error'>
                    {errorsEditProfile.city && errorsEditProfile.city?.type === "required" && (
                      "Paikkakunta on pakollinen kenttä"
                    )}
                  </div>
                </div>

                <div className="input_container">
                  <span>Maa</span>
                  <select  id="country"   onChange={e => updateUserProfile2(() => ({ ...userProfile2, country: e.target.value }))} {...registerEditProfile("country",{ required: false })}><option value="AF">Afghanistan</option><option value="AX">Åland Islands</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia, Plurinational State of</option><option value="BQ">Bonaire, Sint Eustatius and Saba</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="BN">Brunei Darussalam</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="CV">Cape Verde</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo</option><option value="CD">Congo, the Democratic Republic of the</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="CI">Côte d'Ivoire</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands (Malvinas)</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="VA">Holy See (Vatican City State)</option><option value="HN">Honduras</option><option value="HK">Hong Kong</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran, Islamic Republic of</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KP">Korea, Democratic People's Republic of</option><option value="KR">Korea, Republic of</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Lao People's Democratic Republic</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao</option><option value="MK">Macedonia, the former Yugoslav Republic of</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia, Federated States of</option><option value="MD">Moldova, Republic of</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory, Occupied</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RE">Réunion</option><option value="RO">Romania</option><option value="RU">Russian Federation</option><option value="RW">Rwanda</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena, Ascension and Tristan da Cunha</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin (French part)</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten (Dutch part)</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="FI">Suomi - Finland</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syrian Arab Republic</option><option value="TW">Taiwan, Province of China</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania, United Republic of</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VE">Venezuela, Bolivarian Republic of</option><option value="VN">Viet Nam</option><option value="VG">Virgin Islands, British</option><option value="VI">Virgin Islands, U.S.</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option></select>
                  <div id="editProfile_country" className='form_error'>
                    {errorsEditProfile.country && errorsEditProfile.country?.type === "required" && (
                      "Maa on pakollinen kenttä"
                    )}
                  </div>
                </div>

                <div className="input_container">
                  <span>Puhelinnumero</span>
                  <input type="text" id="phoneNumber" className={errorsEditProfile.phoneNumber ? 'invalid' : ''} onChange={e => updateUserProfile2(() => ({ ...userProfile2, phoneNumber: e.target.value }))} {...registerEditProfile("phoneNumber",{ required: false, minLenght: 5 })}/>
                  <div id="editProfile_phoneNumber" className='form_error'>
                    {errorsEditProfile.phoneNumber && errorsEditProfile.phoneNumber?.type === "required" && (
                      "Puhelinnumero on pakollinen kenttä"
                    )}
                    {errorsEditProfile.phoneNumber && errorsEditProfile.phoneNumber?.type === "minLenght" && (
                      "Puhelinnumerossa on oltava vähintään 5 merkintää"
                    )}
                  </div>
                </div>

                <div className="input_container">
                  <span>Yrityksen nimi </span>
                  <input type="text" className={errorsEditProfile.companyName ? 'invalid' : ''} id="companyName" onChange={e => updateUserProfile2(() => ({ ...userProfile2, companyName: e.target.value }))} {...registerEditProfile("companyName",{ required: false })}/>
                   <div id="editProfile_companyName" className='form_error'>
                    {errorsEditProfile.companyName && errorsEditProfile.companyName?.type === "required" && (
                      "Yrityksen nimi on pakollinen kenttä"
                    )}
                  </div>
                </div>

                <div className="input_container lastFormButtonMb20">
                  <span>Yrityksen Y-tunnus </span>
                  <input type="text" id="companyID" {...registerEditProfile("companyID",{ required: false })} onChange={checkCompanyIDvalidation} />
                   <div id="editProfile_companyID" className='form_error'>
                    {errorsEditProfile.companyID && errorsEditProfile.companyID?.type === "required" && (
                      "Yrityksen Y-tunnus on pakollinen kenttä"
                    )}
                  </div>
                </div>

                <div className="button_container">
                  <button type="submit" className="userProfile_save save_button_edit">Tallenna</button>
                  <button className="userProfile_dont_save save_button_edit_outline" onClick={e => goBackWithoutChanges()}>Palaa tallentamatta</button>
                </div>


              </form>
            </div>
          </div>
        </div>
      )
    }
    {
      pageInfo.page === 'editUser' && (
        <div className="content p0">
        <div className="user_account_edit">
          <div className="breadcrumb"><div onClick={event => props.onChange('landing')}>Oma eKukka</div> &gt; <div onClick={() => changeTo('userProfile')}>Omat tiedot</div> &gt; <div className="noPointer">Oma eKukka -jäsenyys</div> </div>
          <div className="h1">Oma eKukka -jäsenyys</div>

            <form onSubmit={handleEditUser(handle_EditUser_submit)}>
              <div className="input_container">
                <span>Jäsenyystunnus (sähköpostiosoite) *</span>
                <input type="email" id="username" value={userProfile.email} className={errorsEditUser.username ? 'invalid' : ''} {...registerEditUser("username",{ required: false })}  disabled/>
                <div id="editUser_username" className='form_error'>
                  {errorsEditUser.username && errorsEditUser.username?.type === "required" && (
                    "sähköpostiosoite on pakollinen kenttä"
                  )}
                </div>
              </div>

              <div className="input_container">
                <span>Nykyinen salasana *</span>
                <input type="password" id="oldpw" className={errorsEditUser.oldpw ? 'invalid' : ''} {...registerEditUser("oldpw",{ required: true })} />
                <div id="editUser_oldpw" className='form_error'>
                  {errorsEditUser.oldpw && errorsEditUser.oldpw?.type === "required" && (
                    "Nykyinen salasana on pakollinen kenttä"
                  )}
                </div>
              </div>

              <div className="input_container">
                <span>Uusi salasana *</span>
                <input type="password" id="newpw" className={errorsEditUser.newpw ? 'invalid' : ''} {...registerEditUser("newpw",{ required: true, minLength: 8 })} />
                <div id="editUser_newpw" className='form_error'>
                  {errorsEditUser.newpw && errorsEditUser.newpw?.type === "required" && (
                    "Uusi salasana on pakollinen kenttä"
                  )}
                  {errorsEditUser.newpw?.type === "minLength" && (
                    "Salasana tulisi olla vähintään 8 merkkiä pitkä"
                  )}
                </div>
              </div>

              <div className="input_container lastFormButtonMb20">
                <span>Uusi salasana uudestaan *</span>
                <input type="password" id="newpwCheck" className={errorsEditUser.newpwCheck ? 'invalid' : ''} {...registerEditUser("newpwCheck",{
                  required: true,
                  validate: {
                      emailEqual: value => (value === getValuesEditUser().newpw)
                  }
                })} />
                <div id="editUser_newpwCheck" className='form_error'>
                  {errorsEditUser.newpwCheck && errorsEditUser.newpwCheck?.type === "required" && (
                    "Uusi salasana uudestaan on pakollinen kenttä"
                  )}
                  {errorsEditUser.newpwCheck?.type === "emailEqual" && (
                      "Salasana ei täsmää"
                  )}
                </div>
              </div>

              <div className='general_error_informer'></div>
              <div className='general_success_informer'></div>

              <div className="button_container">
                <button type="submit" className="userProfile_save save_button_edit">Tallenna</button>
                <button className="userProfile_dont_save save_button_edit_outline" onClick={e => goBackWithoutChanges()}>Palaa tallentamatta</button>
              </div>


            </form>
          </div>
        </div>
      )
    }
    {
      pageInfo.page === 'deleteUser' && (



        <div className="content p0 mb30">

          <div className="user_account_edit">
            {ScrollToTheTop()}
            <div className="breadcrumb"><div onClick={event => props.onChange('landing')}>Oma eKukka</div> &gt; <div onClick={() => changeTo('userProfile')}>Omat tiedot</div> &gt; <div className="noPointer">Jäsenyyden lopetus</div> </div>

            <div className="h1">Jäsenyyden lopetus</div>
            <div className="checkbox_container font_16"><div id="delete_checkbox" className="checkbox" onClick={event => checkbox_change(event.target)}><div className="checker"/></div><span>Kyllä, haluan lopettaa jäsenyyteni Oma eKukassa. *</span></div>

            <form onSubmit={handleDeleteUser(handle_DeleteUser_submit)}>
              <div className="input_container lastFormButtonMb20">
                <span>sähköpostiosoite *</span>
                <input type="email" id="email" name="email" className={errorsDeleteUser.email ? 'invalid' : ''} {...registerDeleteUser("email",{ required: true })} />
                <div id="editUser_oldpw" className='form_error'>
                  {errorsDeleteUser.email && errorsDeleteUser.email?.type === "required" && (
                    "sähköpostiosoite on pakollinen kenttä"
                  )}
                </div>
              </div>

              <div className='general_error_informer'></div>
              <div className="button_container">
                <button type="submit" className="deleteAccout_button delete_button">Lopeta jäsenyys</button>
                <button className="userProfile_dont_save save_button_edit_outline" onClick={e => goBackWithoutChanges()}>Palaa tallentamatta</button>
              </div>
            </form>
          </div>
        </div>
      )
    }
    </div>
  )
}
export default UserProfile;
